import { Input } from 'semantic-ui-react';

import configureInput from './configureInput';

export default configureInput(Input);
